import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/ai-ui-top.png'


const _hoisted_1 = { class: "create-ai-box" }
const _hoisted_2 = {
  class: "create-ai-item",
  align: "center",
  justify: "space-between"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "price" }
const _hoisted_5 = {
  class: "create-ai-item",
  align: "center",
  justify: "space-between"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "price" }
const _hoisted_8 = { class: "select" }
const _hoisted_9 = { class: "select" }
const _hoisted_10 = { style: {"width":"100%","display":"flex","justify-content":"center","margin-top":"10px"} }
const _hoisted_11 = { style: {"font-size":"38px","font-weight":"bold"} }
const _hoisted_12 = { style: {"margin":"10px 0px","font-size":"20px","margin-top":"30px"} }
const _hoisted_13 = {
  key: 1,
  class: "pc-home-body"
}
const _hoisted_14 = { class: "pc-home-content" }
const _hoisted_15 = { class: "pc-row" }
const _hoisted_16 = {
  class: "pc-lie t1",
  style: {"justify-content":"center"}
}
const _hoisted_17 = { style: {"font-size":"64px","font-weight":"bold"} }
const _hoisted_18 = { style: {"color":"rgba(255,255,255,0.6)"} }
const _hoisted_19 = { class: "grid-box" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "grid-content" }
const _hoisted_22 = { class: "grid-item" }
const _hoisted_23 = {
  class: "pc-row",
  style: {"align-items":"center"}
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { style: {"font-size":"18px"} }
const _hoisted_26 = {
  key: 0,
  style: {"font-size":"14px","opacity":"0.4","margin-top":"10px"}
}
const _hoisted_27 = { class: "grid-box" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "grid-content" }
const _hoisted_30 = { class: "grid-item" }
const _hoisted_31 = {
  class: "pc-row",
  style: {"align-items":"center"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { style: {"font-size":"18px"} }
const _hoisted_34 = {
  key: 0,
  style: {"font-size":"14px","opacity":"0.4","margin-top":"10px"}
}
const _hoisted_35 = { class: "grid-box" }
const _hoisted_36 = { class: "title" }
const _hoisted_37 = { class: "grid-content" }
const _hoisted_38 = { style: {"font-size":"18px","margin-left":"5px"} }

import { useLocale } from '@/hooks/useLocale';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useUserStore } from '@/store/UserStore';
import { fetchGetAiProductListAsync } from '@/typescript/Services/Api/AiProduct';
import { fetchCreateAiOrderForUserAsync, fetchGetMyAiOrderLimitFromAiProducIdAsync, InputCreateAiOrder } from '@/typescript/Services/Api/OrderApi';
import { fetchGetProductListForUserAsync } from '@/typescript/Services/Api/ProductApi';
import { request } from '@/typescript/Services/request';
import Global from '@/utils/Global';
import Tools from '@/utils/Tools';
import { inject, ref, watch } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeComponent',
  setup(__props) {

const IsMobile = inject<boolean>("IsMobile");
const local = useLocale();
const systemStore = useSystemConfigStore();
const userStore = useUserStore();
const aiObj = ref<{
    show: boolean;
    list: (DB.AiProduct & { UseCount: number })[],
    loading: boolean
}>({
    show: false,
    loading: true,
    list: []
});

const createAiObj = ref<{
    show: boolean,
    data?: DB.AiProduct & {
        UseCount: number
    },
    input_products: DB.Product[],
    input_data: InputCreateAiOrder
}>({
    show: false,
    input_products: [],
    input_data: {
        BuyCost: 1,
        ProductId: 0,
        AiProductId: 0
    }
});

const xzList = ref<{
    title: string,
    icon: string,
    desc: string
}[]>([
    {
        title: local.t('components.HomeComponent.xzlist.t1'),
        desc: local.t('components.HomeComponent.xzlist.t1_desc'),
        icon: require("@/assets/images/home_icons/1.png"),
    },
    {
        title: local.t('components.HomeComponent.xzlist.t2'),
        desc: local.t('components.HomeComponent.xzlist.t2_desc'),
        icon: require("@/assets/images/home_icons/2.png"),
    },
    {
        title: local.t('components.HomeComponent.xzlist.t3'),
        desc: local.t('components.HomeComponent.xzlist.t3_desc'),
        icon: require("@/assets/images/home_icons/3.png")
    },
    {
        title: local.t('components.HomeComponent.xzlist.t4'),
        desc: local.t('components.HomeComponent.xzlist.t4_desc'),
        icon: require("@/assets/images/home_icons/4.png"),

    },
    {
        title: local.t('components.HomeComponent.xzlist.t5'),
        desc: local.t('components.HomeComponent.xzlist.t5_desc'),
        icon: require("@/assets/images/home_icons/5.png"),

    },
    {
        title: local.t('components.HomeComponent.xzlist.t6'),
        desc: local.t('components.HomeComponent.xzlist.t6_desc'),
        icon: require("@/assets/images/home_icons/6.png"),

    },

]);

const aqhgList = ref<{
    title: string,
    icon: string,
    desc: string
}[]>([
    {
        title: local.t('components.HomeComponent.aqhglist.t1'),
        icon: require("@/assets/images/home_icons/7.png"),
        desc: ""
    },
    {
        title: local.t('components.HomeComponent.aqhglist.t2'),
        icon: require("@/assets/images/home_icons/8.png"),
        desc: ""
    },
    {
        title: local.t('components.HomeComponent.aqhglist.t3'),
        icon: require("@/assets/images/home_icons/9.png"),
        desc: ""
    }

]);


watch(() => userStore.getUser.Uid, (_n, _o) => {
    GetAiProductList();
    GetProductListForUser();
}, {
    immediate: true
});

watch(() => createAiObj.value.input_data.BuyCost, (_n, _o) => {
    
    if (_n < createAiObj.value.data!.MinAmount!) {
        createAiObj.value.input_data.BuyCost = createAiObj.value.data!.MinAmount!;
    }
    else if (_n > createAiObj.value.data!.MaxAmount!) {
        createAiObj.value.input_data.BuyCost = createAiObj.value.data!.MaxAmount!;
    }
});


function GetLeverageList(v: string | number[]) {
    if (typeof v == "string")
        v = JSON.parse(v);
    return v;
}

function GetAiProductList() {
    aiObj.value.loading = true;
    fetchGetAiProductListAsync().then(resp => {
        if (resp.CheckIsOk()) {
            aiObj.value.list = resp.data!;
        }
        aiObj.value.loading = false;
    });
}

/**
 * 显示投资窗口
 */
function ShowInvest(aiProduct: DB.AiProduct & {
    UseCount: number
}) {
    createAiObj.value.data = aiProduct;
    createAiObj.value.input_data.AiProductId = aiProduct.Id!;

    //处理下金额
    createAiObj.value.input_data.BuyCost = aiProduct.MinAmount ?? 1;

    createAiObj.value.show = true;
    UpdateProductUseCount(aiProduct);
}

function UpdateProductUseCount(aiProduct: DB.AiProduct & {
    UseCount: number
}) {
    GetMyAiOrderLimitFromAiProducId(aiProduct).then(useCount => {
        aiProduct.UseCount = useCount;
    });
}

/**
 * 获取我的AI订单已经使用的限额数量
 * @param aiProduct 
 */
async function GetMyAiOrderLimitFromAiProducId(aiProduct: DB.AiProduct) {
    const resp = await fetchGetMyAiOrderLimitFromAiProducIdAsync(aiProduct.Id);
    if (resp.CheckIsOk())
        return resp.data!.useCount;
    return 0;
}

/**
 * 创建AI订单
 */
function ToCreateAiOrder() {
    //进行下单提交
    fetchCreateAiOrderForUserAsync(createAiObj.value.input_data).then(resp => {
        if (resp.CheckIsOk()) {
            Tools.AlertSuccess("AI task has been submitted!");
            CloseInvest();
        }
    });
}


/**
 * 关闭投资窗口
 */
function CloseInvest() {
    createAiObj.value.show = false;
}

function GetProductListForUser() {
    fetchGetProductListForUserAsync(true).then(resp => {
        if (resp.CheckIsOk()) {
            const list = resp.data!;
            createAiObj.value.input_products = list;
            createAiObj.value.input_data.ProductId = list[0].Id!;
        }
    })
}




return (_ctx: any,_cache: any) => {
  const _component_VarImage = _resolveComponent("VarImage")!
  const _component_VarSpace = _resolveComponent("VarSpace")!
  const _component_VarOption = _resolveComponent("VarOption")!
  const _component_VarSelect = _resolveComponent("VarSelect")!
  const _component_var_counter = _resolveComponent("var-counter")!
  const _component_VarButton = _resolveComponent("VarButton")!
  const _component_VarPopup = _resolveComponent("VarPopup")!
  const _component_var_swipe_item = _resolveComponent("var-swipe-item")!
  const _component_var_swipe = _resolveComponent("var-swipe")!
  const _component_VarCol = _resolveComponent("VarCol")!
  const _component_VarDivider = _resolveComponent("VarDivider")!
  const _component_VarRow = _resolveComponent("VarRow")!
  const _component_VarCard = _resolveComponent("VarCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VarPopup, {
      class: _normalizeClass(['create-ai-box-popup', _unref(IsMobile) ? 'phone-create-ai-box-popup' : '']),
      show: createAiObj.value.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((createAiObj.value.show) = $event)),
      "default-style": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: _normalizeStyle({ width: _unref(IsMobile) ? '100%' : '350px', borderRadius: '10px' })
        }, [
          _createVNode(_component_VarSpace, {
            class: "create-ai-box-title",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VarImage, {
                radius: "50%",
                width: "20",
                height: "20",
                src: _ctx.$R(createAiObj.value.data?.Icon)
              }, null, 8, ["src"]),
              _createElementVNode("span", null, _toDisplayString(createAiObj.value.data?.Title), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('components.HomeComponent.controller.danjia')), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(createAiObj.value.data?.MinAmount) + "-" + _toDisplayString(createAiObj.value.data?.MaxAmount) + _toDisplayString(_ctx.$t('components.HomeComponent.controller.meiyuan')), 1)
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "line" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('components.HomeComponent.controller.zdsl')), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(createAiObj.value.data?.UseCount) + "/" + _toDisplayString(createAiObj.value.data?.MaxOrderCount), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_VarSelect, {
                placeholder: _ctx.$t('components.HomeComponent.controller.qxztzcp'),
                modelValue: createAiObj.value.input_data.ProductId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createAiObj.value.input_data.ProductId) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createAiObj.value.input_products, (v) => {
                    return (_openBlock(), _createBlock(_component_VarOption, {
                      label: v.Dn,
                      value: v.Id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(v.Dn), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_var_counter, {
                "input-text-size": "18px",
                "input-width": "100%",
                "button-size": "36px",
                style: {"margin-top":"20px"},
                min: createAiObj.value.data?.MinAmount,
                max: createAiObj.value.data?.MaxAmount,
                modelValue: createAiObj.value.input_data.BuyCost,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createAiObj.value.input_data.BuyCost) = $event)),
                step: createAiObj.value.data?.StepAmount ?? 1
              }, null, 8, ["min", "max", "modelValue", "step"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_VarButton, {
                style: {"width":"40%"},
                class: "tz-btn",
                size: "normal",
                type: "primary",
                onClick: ToCreateAiOrder
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('components.HomeComponent.controller.ljtz')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_VarButton, {
                style: {"margin-left":"10px"},
                class: "close-btn",
                size: "normal",
                onClick: CloseInvest
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('components.HomeComponent.controller.quxiao')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 4)
      ]),
      _: 1
    }, 8, ["class", "show"]),
    (_unref(IsMobile))
      ? (_openBlock(), _createBlock(_component_VarRow, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_VarCol, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_var_swipe, { class: "swipe-example" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_var_swipe_item, null, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("img", {
                          class: "swipe-example-image",
                          src: _imports_0
                        }, null, -1)
                      ])),
                      _: 1,
                      __: [4]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_VarCol, {
              offset: 1,
              span: 22,
              justify: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VarSpace, { direction: "column" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t1')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t2')) + _toDisplayString(_unref(systemStore).config?.SystemName) + " " + _toDisplayString(_ctx.$t('components.HomeComponent.contents.t3')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_VarCol, {
              span: 24,
              justify: "center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t4')), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiObj.value.list, (v) => {
              return (_openBlock(), _createBlock(_component_VarCol, {
                span: 24,
                key: v.Id,
                style: {"margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VarCard, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_VarRow, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_VarCol, {
                            span: 24,
                            align: "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VarImage, {
                                radius: "50%",
                                width: "50",
                                src: _ctx.$R(v.Icon)
                              }, null, 8, ["src"]),
                              _createElementVNode("span", null, _toDisplayString(v.Title), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_VarCol, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_VarImage, {
                                src: _ctx.$R(v.DetailImg)
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_VarCol, {
                            span: 24,
                            style: {"margin-top":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VarRow, { style: {"width":"100%"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_VarCol, {
                                    span: 10,
                                    align: "start",
                                    direction: "column"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.HomeComponent.contents.jiage')), 1),
                                      _createElementVNode("span", null, "$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MinAmount ?? 0, 2)) + "-$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MaxAmount
                                                ??
                                                0,
                                                2)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_VarCol, { span: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_VarDivider, { vertical: true })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_VarCol, {
                                    span: 12,
                                    align: "end",
                                    direction: "column"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.HomeComponent.contents.lirun')), 1),
                                      _createElementVNode("span", null, "$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MinAmount! * v.MinProfitPercentage!, 2)) + "-$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MaxAmount! *
                                                v.MaxProfitPercentage!, 2)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_VarCol, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VarDivider)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_VarCol, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VarRow, { style: {"width":"100%"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_VarCol, {
                                    span: 12,
                                    justify: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.HomeComponent.contents.mrzdxdl')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_VarCol, {
                                    span: 12,
                                    justify: "end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(v.MaxOrderCount), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_VarCol, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VarDivider)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_VarCol, {
                            span: 24,
                            style: {"width":"100%","margin-top":"20px"},
                            justify: "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VarButton, {
                                type: "primary",
                                style: {"width":"60%"},
                                onClick: ($event: any) => (ShowInvest(v))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('components.HomeComponent.contents.ljtz')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t1')), 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t2')) + _toDisplayString(_unref(systemStore).config?.SystemName) + " " + _toDisplayString(_ctx.$t('components.HomeComponent.contents.t3')), 1)
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "pc-row" }, [
                _createElementVNode("img", {
                  class: "swipe-example-image",
                  src: _imports_0
                })
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t5')) + " " + _toDisplayString(_unref(systemStore).config?.SystemName) + "？", 1),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xzList.value, (v) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("img", {
                        style: {"border-radius":"50%"},
                        src: v.icon,
                        width: "32px",
                        height: "32px"
                      }, null, 8, _hoisted_24),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(v.title), 1)
                    ]),
                    (v.desc)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(v.desc), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t6')), 1),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aqhgList.value, (v) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        style: {"border-radius":"50%"},
                        src: v.icon,
                        width: "32px",
                        height: "32px"
                      }, null, 8, _hoisted_32),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(v.title), 1)
                    ]),
                    (v.desc)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(v.desc), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.$t('components.HomeComponent.contents.t4')), 1),
              _createElementVNode("div", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiObj.value.list, (v) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "grid-item",
                    key: v.Id,
                    style: {"font-size":"12px"}
                  }, [
                    _createVNode(_component_VarRow, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_VarCol, {
                          span: 24,
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VarImage, {
                              radius: "50%",
                              width: "50",
                              src: _ctx.$R(v.Icon)
                            }, null, 8, ["src"]),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(v.Title), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_VarCol, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_VarImage, {
                              src: _ctx.$R(v.DetailImg)
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_VarCol, {
                          span: 24,
                          style: {"margin-top":"5px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VarRow, { style: {"width":"100%"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_VarCol, {
                                  span: 10,
                                  align: "start",
                                  direction: "column"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.HomeComponent.contents.jiage')), 1),
                                    _createElementVNode("span", null, "$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MinAmount ?? 0, 2)) + "-$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MaxAmount
                                                        ??
                                                        0,
                                                        2)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_VarCol, { span: 2 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_VarDivider, { vertical: true })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_VarCol, {
                                  span: 12,
                                  align: "end",
                                  direction: "column"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.HomeComponent.contents.lirun')), 1),
                                    _createElementVNode("span", null, "$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MinAmount! * v.MinProfitPercentage!,
                                                    2)) + "-$" + _toDisplayString(_unref(Tools).TruncateDecimal(v.MaxAmount! * v.MaxProfitPercentage!,
                                                        2)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_VarCol, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VarDivider)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_VarCol, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VarRow, { style: {"width":"100%"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_VarCol, {
                                  span: 12,
                                  justify: "start"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.HomeComponent.contents.mrzdxdl')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_VarCol, {
                                  span: 12,
                                  justify: "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(v.MaxOrderCount), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_VarCol, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VarDivider)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_VarCol, {
                          span: 24,
                          style: {"width":"100%","margin-top":"20px"},
                          justify: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VarButton, {
                              type: "primary",
                              style: {"width":"60%"},
                              onClick: ($event: any) => (ShowInvest(v))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('components.HomeComponent.contents.ljtz')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
  ]))
}
}

})